e4.bootstrap.dropdown = {
    init: function () {
        e4.bootstrap.dropdown.bindEvents();
    },
    bindEvents: function () {
        // Prevent dropdown menu from closing when clicking child nodes.
        jQuery( document ).on( 'click.bs.dropdown.data-api', '.dropdown-menu.show', function ( event ) {
            var jTarget = jQuery( event.target );
            console.log('click.bs.dropdown.data-api')
            if ( jTarget.closest( '[data-dismiss="dropdown"], .js-e-dropdown-dismiss' ).length === 0 ) {
                event.stopPropagation();
                console.warn('click.bs.dropdown.data-api event.stopPropagation()')
            }
        } );
    }
};
